import React from "react";
import ListItemReversedTextView from "../../../../../common/components/ListItemReversedTextView";

export interface UnitTopicViewProp {
    unit?: string;
    topic?: string;
}

export default function UnitTopicView({unit, topic}: UnitTopicViewProp) {

    if (!unit && !topic) {
        return null;
    }

    const content = unit === "Custom" ? unit : `${unit} | ${topic}`;

    return (
        <ListItemReversedTextView title={`Location`} content={content}/>
    );
}
